<template>
  <div class="movie-list-container">
    <div v-for="item in data" class="movie-item-container" @click="showDetailItem(item)">
      <div class="movie-item" v-if="item.type === 4 || item.type === 5">
        <div class="cover-container">
          <img v-lazy="coverUrlMovie(item)" :key="item.id" class="cover"/>
        </div>
        <div class="movie-info-box">
          <div class="title-info">{{item.title}}</div>
          <div class="description-info">
            {{movieDescriptions(item)}}
          </div>
        </div>
      </div>
      <div class="movie-item" v-if="item.type === 0" @click="showDetailItem(item)">
        <div class="cover-container">
          <img v-lazy="item.cover_url" :key="item.id" class="cover"/>
        </div>
        <div class="video-title-container">
          <div class="title-info">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MovieItemList",
    components: {},
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      showDetailItem(item) {
        if (item.type === 2) {
          this.$router.push('/novel/' + item.id);
        } else if (item.type === 0) {
          this.$router.push('/video/' + item.id);
        } else if (item.type === 4 || item.type === 5 ) {
          this.$router.push("/movie/" + item.id)
        }
      },
      movieDescriptions(movieItem) {
        let movieInfo = movieItem.movie_info
        let result = ''
        if (movieInfo.tags) {
          result += '' + movieInfo.tags

        } else if (movieInfo.alias) {
          result += '别名：' + movieInfo.alias
        }
        return result
      },
      coverUrlMovie(item) {
        if (item.preview_urls) {
          return item.preview_urls[0]
        } else {
          return ""
        }
      }
    },
    computed: {}
  };
</script>

<style lang="scss" scoped>

  .movie-list-container {
    width: 100%;
    background: white;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .movie-item-container {
    width: 50%;
    margin-top: 3px;

    .movie-item {
      padding: 0 2px;
    }

    .video-title-container {
      color: rgba(34, 34, 34, 0.78);
      margin: 8px 3px;
      font-size: 14px;
      line-height: 1.2;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* number of lines to show */
    }

    .cover-container {
      width: 100%;
      overflow: hidden;
      height: 110px;
      background: #fafafa;
      position: relative;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;

      .cover {
        width: 100%;
        top: 50%;
        left: 50%;
        display: block;
        position: absolute;

        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);

        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
      }
    }

    .movie-info-box {
      color: #222;
      padding: 8px 3px;

      .title-info {
        font-size: 14px;
      }

      .description-info {
        margin-top: 5px;
        font-size: 12px;
        line-height: 1.5;
        max-height: 36px;
        overflow: hidden;
        color: #7c7c7c;
      }
    }
  }

</style>
